<template>
  <div class="mw-panel mw-bar-data">
    <toolbar-table :layout="layout" ref="toolbarTable"></toolbar-table>

    <mw-dialog size="mini_small" :footerButton="btns" ref="setDeptDialog"
               title="选择部门机构" :close-on-click-modal="false">
      <div class="invalid-user-dept-sel">
        <mw-tree :url="deptTreeUrl"
                 :async="true" :expandedFirst="true"
                 ref="deptTree" :multiple="false" class="mw-dialog-body"
        ></mw-tree>
      </div>
    </mw-dialog>

  </div>
</template>
<script>


  export default {

    data() {
      let me = this;
      return {
        layout: [],
        btnNotShowIcon:(window.$Env && $Env.btnNotShowIcon),
        // deptTreeUrl: this.mwUrl('/api/org/listDepartment'),
        btns: [{
          label: '确定', func: this.setUserDeptSure
        }, {
          label: '取消', func: this.cancelChoose, type: 'default'
        }],
        userIds: []
      }
    },
    computed: {
      deptTreeUrl() {
        // 不是开发账号过滤不显示的部门
        if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
        return this.mwUrl("/api/org/listDepartment")
      }
    },
    mounted() {
      let me = this;
      let filterInvalidLoginIds = window.$Env && $Env.filterInvalidLoginIds||"";
      me.layout = [
        [{
          span: 0,
          type: 'menu',
          label: '无效用户',
          api: 'org.listUserPaging',
          defaultParams: {active: 0,filterLoginId:filterInvalidLoginIds},
          columns: [
            {type: 'selection'},
            //{type: 'index'},
            {prop: 'loginId', label: '账号', tooltip: true},
            {prop: 'name', label: '名称', tooltip: true},
            {prop: 'tel', label: '座机电话', tooltip: true},
            {prop: 'mobile', label: '移动电话', tooltip: true},
            {prop: 'email', label: '电子邮箱', tooltip: true},
            {prop: 'lastModifiedTime', label: '最近修改时间', tooltip: true}
          ]
        }, {
          span: 8,
          type: 'button',
          items: [{
            label: '设置部门',
            icon: me.btnNotShowIcon ? '':'fa fa-plus-square',
            func: me.setDept
          }, {
            label: '删除',
            icon: me.btnNotShowIcon ? '':'fa fa-trash-o fa-fw',
            func: me.deleteUsers
          }]
        }, {
          span: 6,
          type: 'searchText',
          offset: 10,
          name: 'name'
        }]
      ]
    },
    methods: {

      setDept(data) {
        if (data.length == 0) {
          this.mwMsg('info', '请选择你要设置的用户')
        } else {
          this.mwRef('setDeptDialog').show();
          let userIds = [];
          data.forEach(r => {
            userIds.push(r.id);
          })
          this.userIds = userIds;
        }
      },

      deleteUsers(data) {
        if (data.length == 0) {
          this.mwMsg('info', '请选择你要操作的用户')
        }
        else {
        this.$confirm('是否要删除此用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let arrIds = [];
          data.forEach(r => {
            arrIds.push(r.id)
          });
          this.mwApi.org.deleteUser(arrIds).then(data => {
            if (data.success) {
              this.mwMsg('删除成功!');
              this.mwRef('toolbarTable').refreshTable();
            }
            else {
              this.mwMsg('info', '删除成功!');
            }
          })

        })


        }

      },

      setUserDeptSure() {

        let departmentId = this.mwRef('deptTree').getSelected().id;
        this.mwApi.org.addDepartmentUser(departmentId, this.userIds).then(data => {
          if (data.success) {
            // this.mwApi.org.deleteUser(this.userIds).then(data => {
                this.mwMsg('设置部门成功!');
                this.mwRef('toolbarTable').refreshTable();
                this.cancelChoose();
            // });

          }

        })
      },
      cancelChoose() {
        this.mwRef('setDeptDialog').hide();
      },
      toUser(){
        this.$router.push({ path: '/set/user'})
      }
    }

  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/InvalidUser.vue